


















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiarioDocumento from "@/models/tramite/tramiteBeneficiarioDocumento.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import fileService, { getDocumentDownloadErrorMessage } from "@/services/file.service";

@Component
export default class TramiteBeneficiarioTableDocumentoComponent extends BaseVue {
  @Prop() readonly controller!: string;
  @Prop() readonly dependencyKey!: string;
  @Prop() readonly dependencyValue!: string;
  @Prop() readonly where!: string;
  documentoTable = new BTableConfig<TramiteBeneficiarioDocumento>();
 
  created() {
    this.setupDocumentoTable();
  }
getWhereParams(){
let result  = '';
if(this.where)
result += this.where;
if(this.dependencyValue)
result += `${this.dependencyKey}=${this.dependencyValue}`;
return result;
}
  setupDocumentoTable() {
    let docType = new BTableColumn("documento.tipoDocumentoNombre","Tipo de documento",false);
    let doc = new BTableColumn("documento.nombreOriginal", "Documento");
    let preview = new BTableColumn("preview", " ", false);
    preview.customTemplate = true;
    preview.width = "60";
    this.documentoTable.controller = this.controller;
    this.documentoTable.enableDefaultColumns = false;
    this.documentoTable.activeActions = false;
    this.documentoTable.include = 'Documento.TipoDocumento';

    this.documentoTable.insertColumns(preview, docType, doc);
    this.$emit('render',this.documentoTable);
  }
 async verDocumento(id: number) {
    try {
      await fileService.download(id);
    } catch (error) {
      this.operationFailed(getDocumentDownloadErrorMessage(error));
    }
  }
   @Watch("dependencyValue", { immediate: true })
  onPersonaIdChange(value: string | undefined | null) {
    if (!value) 
      return;
    this.documentoTable.whereParams = this.getWhereParams();
    if (this.documentoTable.reload) this.documentoTable.reload();
  }
}
